"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var log = _Logger.default.namespace('Welcome.vue');
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default
  },
  data: function data() {
    return {
      connectErrors: [],
      network: null,
      channel: '',
      nick: '',
      password: '',
      showChannel: true,
      showPass: true,
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false,
      oauthToken: null
    };
  },
  computed: {
    isIframe: function isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions: function startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText: function footerText() {
      var footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    termsContent: function termsContent() {
      var terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    isNickValid: function isNickValid() {
      var nickPatternStr = this.$state.setting('startupOptions.nick_format');
      var nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        var pattern = '';
        var flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          var pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart: function readyToStart() {
      var ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }

      // Make sure the channel name starts with a common channel prefix
      if (!this.connectWithoutChannel) {
        var bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(function (bufferObj) {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }

      // If toggling the password is is disabled, assume it is required
      if (!this.toggablePass && !this.password) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  watch: {
    show_password_box: function show_password_box(newVal) {
      if (newVal === false) {
        // clear the password when show password is unchecked
        this.password = '';
      }
    }
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _context;
      var options, showPasswordOverride, connectOptions, previousNet, _context2, oauthToken, url, showPassVal, bouncer, autoConnect;
      return _regenerator.default.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            options = _this.startupOptions;
            showPasswordOverride = _this.getShowPasswordQueryOverride();
            connectOptions = _this.connectOptions(); // Take some settings from a previous network if available
            previousNet = null;
            if ((0, _trim.default)(_context = connectOptions.hostname).call(_context)) {
              previousNet = _this.$state.getNetworkFromAddress((0, _trim.default)(_context2 = connectOptions.hostname).call(_context2));
            }
            if (previousNet && previousNet.connection.nick) {
              _this.nick = previousNet.connection.nick;
            } else if (Misc.queryStringVal('nick')) {
              _this.nick = Misc.queryStringVal('nick');
            } else {
              _this.nick = options.nick;
            }
            _this.nick = _this.processNickRandomNumber(_this.nick || '');
            if (options.password) {
              _this.password = options.password;
            } else if (previousNet && previousNet.password) {
              _this.password = previousNet.password;
              _this.show_password_box = true;
            } else {
              _this.password = '';
            }

            // Store OAuth token for NickServ authentication
            oauthToken = Misc.queryStringVal('oauth_token');
            if (oauthToken) {
              _this.oauthToken = oauthToken;
              log('OAuth token received from URL, length:', oauthToken.length);
              // Don't show password box when using OAuth
              _this.show_password_box = false;
              _this.password = '';

              // Clean the token from URL for security
              url = new _url.default(window.location);
              url.searchParams.delete('oauth_token');
              window.history.replaceState({}, document.title, url.toString());
            }

            // Optional URL param override for prompting password
            // - show_password=true  => showPassword=true,  autoConnect=false
            // - show_password=false => showPassword=false, autoConnect=true
            if (showPasswordOverride === true) {
              _this.show_password_box = true;
            } else if (showPasswordOverride === false) {
              _this.show_password_box = false;
              _this.password = '';
            }
            _this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
            _this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
            _this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
            showPassVal = true;
            if (showPasswordOverride !== null) {
              showPassVal = showPasswordOverride;
            } else if (typeof options.showPassword === 'boolean') {
              showPassVal = options.showPassword;
            }
            _this.showPass = showPassVal;
            _this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
            _this.connectWithoutChannel = !!options.allowNoChannel;
            if (options.bouncer) {
              _this.toggablePass = false;
              _this.showPass = true;
              _this.showChannel = false;
              _this.connectWithoutChannel = true;
              bouncer = new _BouncerProvider.default(_this.$state);
              bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
            }
            autoConnect = showPasswordOverride !== null ? !showPasswordOverride : options.autoConnect;
            if (autoConnect && _this.readyToStart) {
              _this.startUp();
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getShowPasswordQueryOverride: function getShowPasswordQueryOverride() {
      var _context4, _context5, _context6;
      var raw = Misc.queryStringVal('show_password');
      if (raw === null) {
        return null;
      }
      var val = (0, _trim.default)(_context4 = String(raw)).call(_context4).toLowerCase();
      if (val === '' || (0, _includes.default)(_context5 = ['1', 'true', 'yes', 'y', 'on']).call(_context5, val)) {
        return true;
      }
      if ((0, _includes.default)(_context6 = ['0', 'false', 'no', 'n', 'off']).call(_context6, val)) {
        return false;
      }
      log.warn("Invalid show_password value: '".concat(raw, "'"));
      return null;
    },
    onAltClose: function onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    startUp: function startUp() {
      var _this2 = this;
      this.connectErrors = [];
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = this.connectOptions();
      var netAddress = (0, _trim.default)(_lodash.default).call(_lodash.default, connectOptions.hostname);

      // Check if we have this network already
      var net = this.network || this.$state.getNetworkFromAddress(netAddress);
      var password = this.password;

      // If the network doesn't already exist, add a new one
      net = net || this.$state.addNetwork('Network', this.nick, {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: options.gecos,
        username: options.username
      });

      // Clear the server buffer in case it already existed and contains messages relating to
      // the previous connection, such as errors. They are now redundant since this is a
      // new connection.
      net.serverBuffer().clearMessages();

      // If we retreived an existing network, update the nick+password with what
      // the user has just put in place
      net.connection.nick = this.nick;
      if (options.bouncer) {
        var _context7;
        // Bouncer mode uses server PASS
        net.connection.password = (0, _concat.default)(_context7 = "".concat(this.nick, ":")).call(_context7, password);
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      if ((0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding || '')) {
        net.connection.encoding = (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding);
      }
      this.network = net;

      // Only switch to the first channel we join if multiple are being joined
      var hasSwitchedActiveBuffer = false;
      var bufferObjs = Misc.extractBuffers(this.channel);
      bufferObjs.forEach(function (bufferObj) {
        var newBuffer = _this2.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          _this2.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });

      // switch to server buffer if no channels are joined
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }
      net.ircClient.connect();
      var _onRegistered = function onRegistered() {
        // Send OAuth token to NickServ if present
        log('onRegistered called, oauthToken:', _this2.oauthToken ? 'present' : 'missing');
        if (_this2.oauthToken) {
          log('Sending IDENTIFYOAUTH to NickServ with nick:', _this2.nick);
          // Add a small delay to ensure server is ready
          setTimeout(function () {
            var _context8;
            net.ircClient.raw((0, _concat.default)(_context8 = "PRIVMSG NickServ IDENTIFYOAUTH ".concat(_this2.nick, " ")).call(_context8, _this2.oauthToken));
            log('IDENTIFYOAUTH command sent');
          }, 1000);

          // Listen for NickServ response
          var onNickServMessage = function onNickServMessage(event) {
            if (event.nick && event.nick.toLowerCase() === 'nickserv') {
              var message = event.message || '';
              // Check for successful authentication
              if ((0, _includes.default)(message).call(message, 'aceptada') || (0, _includes.default)(message).call(message, 'accepted') || (0, _includes.default)(message).call(message, 'reconocido') || (0, _includes.default)(message).call(message, 'identified')) {
                log('NickServ OAuth authentication successful');
              }
            }
          };
          net.ircClient.on('privmsg', onNickServMessage);

          // Clean up listener after 30 seconds
          setTimeout(function () {
            net.ircClient.off('privmsg', onNickServMessage);
          }, 30000);
        }
        if (_this2.$refs.layout) {
          _this2.$refs.layout.close();
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var _onClosed = function onClosed() {
        var _context9;
        var lastError = _this2.network.last_error;
        if (lastError && !(0, _includes.default)(_context9 = _this2.connectErrors).call(_context9, lastError)) {
          _this2.connectErrors.push(lastError);
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var onError = function onError(event) {
        var _context0;
        if (!event.reason || (0, _includes.default)(_context0 = _this2.connectErrors).call(_context0, event.reason)) {
          return;
        }
        _this2.connectErrors.push(event.reason);
      };
      net.ircClient.once('registered', _onRegistered);
      net.ircClient.once('close', _onClosed);
      net.ircClient.on('irc error', onError);
    },
    exchangeAuthCode: function exchangeAuthCode(authCode) {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var response, errorData, data, url, _t;
        return _regenerator.default.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              log('Exchanging auth code:', authCode);
              // Use a relative path to the API endpoint
              _context1.next = 1;
              return fetch('/accounts/api/exchange-irc-token/', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify.default)({
                  auth_code: authCode
                })
              });
            case 1:
              response = _context1.sent;
              if (response.ok) {
                _context1.next = 3;
                break;
              }
              _context1.next = 2;
              return response.json();
            case 2:
              errorData = _context1.sent;
              log.error('Failed to exchange auth code:', errorData);
              throw new Error(errorData.error || 'Failed to exchange auth code');
            case 3:
              _context1.next = 4;
              return response.json();
            case 4:
              data = _context1.sent;
              _this3.oauthToken = data.oauth_token;
              log('OAuth token received, length:', _this3.oauthToken ? _this3.oauthToken.length : 0);

              // Clean the URL
              url = new _url.default(window.location);
              url.searchParams.delete('auth_code');
              window.history.replaceState({}, document.title, url.toString());
              _context1.next = 6;
              break;
            case 5:
              _context1.prev = 5;
              _t = _context1["catch"](0);
              log.error('Error exchanging auth code:', _t);
              _this3.connectErrors.push(_t.message);
            case 6:
            case "end":
              return _context1.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }))();
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      // Replace ? with a random number
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return (0, _trim.default)(_lodash.default).call(_lodash.default, tmp);
    },
    handleCaptcha: function handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions: function connectOptions() {
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = Misc.connectionInfoFromConfig(options);

      // If a server isn't specified in the config, set some defaults
      // The webircgateway will have a default network set and will connect
      // there instead. This just removes the requirement of specifying the same
      // irc network address in both the server-side and client side configs
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;
